"use client";

import * as React from "react";

import { fields } from "@keystatic/core";
import { block } from "@keystatic/core/content-components";

/**
 * Keystatic block for the in-article CTA buttons migrated from WordPress
 * (`mid_button` / `end_button` ACF fields). Stores plain text + URL in the
 * `.mdoc` source; rendering happens in `MarkdocRenderer` (green gradient
 * primary button).
 */

const SCHEMA = {
  text: fields.text({ label: "Button text" }),
  url: fields.url({ label: "Target URL" }),
} as const;

type CtaButtonValue = { text: string; url: string | null };

const CtaButtonNodeView: React.FC<{
  value: CtaButtonValue;
  onChange: (next: CtaButtonValue) => void;
  onRemove: () => void;
  isSelected: boolean;
}> = ({ value, isSelected }) => (
  <div
    style={{
      display: "flex",
      justifyContent: "center",
      margin: "1rem 0",
    }}
  >
    <span
      style={{
        display: "inline-block",
        padding: "0.5rem 1.25rem",
        borderRadius: 9999,
        background: "linear-gradient(135deg, #16a34a, #15803d)",
        color: "#ffffff",
        fontSize: 14,
        outline: isSelected ? "2px solid #16a34a" : "none",
        outlineOffset: 2,
      }}
    >
      {value.text || "CTA button"}
    </span>
  </div>
);

export const ctaButtonComponent = block({
  label: "CTA button",
  description: "Centered call-to-action button (green gradient).",
  schema: SCHEMA,
  NodeView: CtaButtonNodeView,
});
